'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('survey-show', {
      url: '/survey/:id',
      template: '<survey-show></survey-show>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/survey/show/survey-show.routes.js